module.exports = __webpack_public_path__ + "img/img6.e9d1b5e8.png";